import { TemplateId } from '../../types/advertising/partnership';
import vipCompactCarMoney from '../partners/vip-compact-carmoney/validate';

import vipCompactAnyvan from '../partners/vip-compact-anyvan/validate';
import vipCompactCarMoneyMonthlyPrice from '../partners/vip-compact-carmoney-monthly-price/validate';
import vipDefaultAnyvan from '../partners/vip-default-anyvan/validate';
import vipDefaultCarMoney from '../partners/vip-default-carmoney/validate';
import vipCompactConfused from '../partners/vip-compact-confused/validate';

export default (templateId: TemplateId) => {
    switch (templateId) {
        case 'vip-default-anyvan':
            return vipDefaultAnyvan;
        case 'vip-compact-carmoney':
            return vipCompactCarMoney;
        case 'vip-compact-carmoney-monthly-price':
            return vipCompactCarMoneyMonthlyPrice;
        case 'vip-compact-anyvan':
            return vipCompactAnyvan;
        case 'vip-default-carmoney':
            return vipDefaultCarMoney;
        case 'vip-compact-confused':
            return vipCompactConfused;
    }
};
